<template>
  <div>
    <ContractTermination :policyId="policyId?.toString() ?? ''"> </ContractTermination>
  </div>
  <div class="imageWrapper">
    <slot name="image">
      <TeaserAccount></TeaserAccount>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import TeaserAccount from '@/componentsTenant/rahmen/images/TeaserAccount.vue'
import { router } from '@/router/router'
import ContractTermination from '@/componentsTenant/motor/ContractTermination.vue'

const policyId = ref(router.currentRoute.value.params.policyId)
</script>

<style scoped lang="scss">
.box-centered {
  max-width: 735px;
  margin: 0 auto;
}

.loading-container {
  position: relative;
  overflow: auto;
}

.imageWrapper {
  padding-top: calc(var(--baseline) * 1.5);
}
</style>
